import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SidebarRight.svg",
  "use": "SidebarRight.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SidebarRight.svg\"><path d=\"M12,52H52a4,4,0,0,0,4-4V16a4,4,0,0,0-4-4H12a4,4,0,0,0-4,4V48A4,4,0,0,0,12,52ZM42,17a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V47a1,1,0,0,1-1,1H43a1,1,0,0,1-1-1ZM12,17a1,1,0,0,1,1-1H37a1,1,0,0,1,1,1V47a1,1,0,0,1-1,1H13a1,1,0,0,1-1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol